module.exports = __webpack_public_path__ + "img/new-caledonia.8b296b78.svg";